var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Joi from 'joi-fresh';
import { useForm, useFieldArray } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { showNotification } from '../../../../common/helpers/notifications';
import { reviewsImport } from '../../actions';
var responseSchema = Joi.object({
    message: Joi.string().required(),
});
var isValidResponse = function (response) {
    if (response === undefined)
        return false;
    return responseSchema.validate(response).value !== undefined;
};
var urlSchema = Joi.string().uri().required();
var schema = Joi.object({
    urls: Joi.array().items(urlSchema).min(1).max(3).required(),
});
export var useReviewsImportForm = function (shopId) {
    var dispatch = useDispatch();
    var _a = useState(''), newUrl = _a[0], setNewUrl = _a[1];
    var _b = useState(''), urlError = _b[0], setUrlError = _b[1];
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onSubmit',
        defaultValues: {
            urls: [],
        },
    });
    var _c = useFieldArray({
        control: form.control,
        name: 'urls',
    }), fields = _c.fields, append = _c.append, remove = _c.remove;
    var canAddMoreUrls = fields.length < 3;
    var validateUrl = function (url) {
        var error = urlSchema.validate(url).error;
        return !error;
    };
    var addUrl = function () {
        if (newUrl.trim() && canAddMoreUrls) {
            if (validateUrl(newUrl.trim())) {
                var trimmedUrl = newUrl.trim();
                append(trimmedUrl);
                setNewUrl('');
                setUrlError('');
            }
            else {
                setUrlError('Please enter a valid URL (e.g., https://example.com)');
            }
        }
    };
    var handleKeyPress = function (e) {
        if (e.key === 'Enter' && newUrl.trim() && canAddMoreUrls) {
            e.preventDefault();
            addUrl();
        }
    };
    var onSubmit = function (model) { return __awaiter(void 0, void 0, void 0, function () {
        var filteredUrls, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    filteredUrls = model.urls.filter(function (url) { return url && url.trim() !== ''; });
                    if (filteredUrls.length === 0) {
                        showNotification({
                            title: 'Error',
                            level: 'error',
                            message: 'Please add at least one URL',
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(reviewsImport(shopId, { urls: filteredUrls }))];
                case 1:
                    response = _a.sent();
                    if (!isValidResponse(response)) {
                        showNotification({
                            title: 'Error',
                            level: 'error',
                            message: 'Failed to import reviews',
                        });
                        return [2 /*return*/];
                    }
                    showNotification({
                        title: 'Success',
                        level: 'success',
                        message: response.message,
                    });
                    form.reset({ urls: [] });
                    remove();
                    setNewUrl('');
                    setUrlError('');
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if (error_1 instanceof Error) {
                        showNotification({
                            title: 'Error',
                            level: 'error',
                            message: error_1.message,
                        });
                    }
                    else {
                        showNotification({
                            title: 'Error',
                            level: 'error',
                            message: 'An unknown error occurred',
                        });
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateNewUrl = function (value) {
        setNewUrl(value);
        if (urlError)
            setUrlError('');
    };
    return {
        form: form,
        onSubmit: onSubmit,
        newUrl: newUrl,
        setNewUrl: updateNewUrl,
        urlError: urlError,
        addUrl: addUrl,
        handleKeyPress: handleKeyPress,
        canAddMoreUrls: canAddMoreUrls,
        urlsFields: fields,
        removeUrlField: remove,
    };
};
